import { createSlice } from "@reduxjs/toolkit";
import {
  addColumnPreferences,
  deleteAttachments,
  getAircraftFamiliy,
  getBamUsers,
  getContants,
  getEngineFamily,
  getEngineFamilyTypes,
  getFilterDropdown,
  getGeneralColumnPreferences,
  getVendorsDropdown,
  upDateColumnPreferences,
} from "./commonActions";

export const initialState = {
  loading: false,
  addLoading: false,
  fetchColumns: false,
  filterDropdownValues: {},
  columnPreferences: {},
  constanst: {},
  airCraftFamiliy: {},
  engineFamily: {},
  engineFamilyTypes: {},
  vendorsDropdown: {},
  bamUsers: {},
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setFetchColumns: (state, action) => {
      state.fetchColumns = action.payload;
    },
    clearCommonState: (state) => {
      state.loading = false;
      state.filterDropdownValues = {};
      state.constanst = {};
      state.engineFamily = {};
      state.engineFamilyTypes = {};
      state.vendorsDropdown = {};
      state.bamUsers = {};
    },
  },
  extraReducers: (builder) => {
    builder

      // get filter dropdown
      .addCase(getFilterDropdown.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFilterDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.filterDropdownValues = action.payload?.data;
      })
      .addCase(getFilterDropdown.rejected, (state, action) => {
        state.loading = false;
      })

      // General Column Preferences
      .addCase(getGeneralColumnPreferences.pending, (state) => {
        state.fetchColumns = true;
      })
      .addCase(getGeneralColumnPreferences.fulfilled, (state, action) => {
        state.fetchColumns = false;

        state.columnPreferences = action.payload.result;
      })
      .addCase(getGeneralColumnPreferences.rejected, (state) => {
        state.fetchColumns = false;
      })
      // ADD Column Preferences
      .addCase(addColumnPreferences.pending, (state) => {
        state.fetchColumns = true;
      })
      .addCase(addColumnPreferences.fulfilled, (state, action) => {
        state.fetchColumns = false;

        state.columnPreferences = action.payload.result;
      })
      .addCase(addColumnPreferences.rejected, (state) => {
        state.fetchColumns = false;
      })

      // Update Column Preferences
      .addCase(upDateColumnPreferences.pending, (state) => {
        state.fetchColumns = true;
      })
      .addCase(upDateColumnPreferences.fulfilled, (state, action) => {
        state.fetchColumns = false;
        state.columnPreferences = action.payload.result.column_preferences;
      })
      .addCase(upDateColumnPreferences.rejected, (state) => {
        state.fetchColumns = false;
      })

      // get constants
      .addCase(getContants.pending, (state) => {
        state.loading = true;
      })
      .addCase(getContants.fulfilled, (state, action) => {
        state.loading = false;
        state.constanst = action.payload?.data || {};
      })
      .addCase(getContants.rejected, (state) => {
        state.loading = false;
      })
      // get air craft family
      .addCase(getAircraftFamiliy.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAircraftFamiliy.fulfilled, (state, action) => {
        state.loading = false;
        state.airCraftFamiliy = action.payload?.data;
      })
      .addCase(getAircraftFamiliy.rejected, (state) => {
        state.loading = false;
      })
      // get engine familty
      .addCase(getEngineFamily.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEngineFamily.fulfilled, (state, action) => {
        state.loading = false;
        state.engineFamily = action.payload?.data;
      })
      .addCase(getEngineFamily.rejected, (state) => {
        state.loading = false;
      })
      // get engine family types
      .addCase(getEngineFamilyTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEngineFamilyTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.engineFamilyTypes = action.payload?.data;
      })
      .addCase(getEngineFamilyTypes.rejected, (state) => {
        state.loading = false;
      })
      // delete attachements
      .addCase(deleteAttachments.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAttachments.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAttachments.rejected, (state) => {
        state.loading = false;
      })
      // get vendos dropdown
      .addCase(getVendorsDropdown.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorsDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.vendorsDropdown = action.payload?.data;
      })
      .addCase(getVendorsDropdown.rejected, (state, action) => {
        state.loading = false;
      })
      // get bam users
      .addCase(getBamUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBamUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.bamUsers = action.payload?.data;
      })
      .addCase(getBamUsers.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
export const { setFetchColumns, fetchColumns, clearCommonState } =
  commonSlice.actions;
export default commonSlice.reducer;
